import type { AllFeatureIds } from 'generated/featureIds.generated'
import last from 'lodash/last'

// TODO: Replace hasFeature with useFeatures once all callers pass the checker explicitly
import hasFeature from 'modules/core/lib/hasFeature'

import type Template from 'modules/reports/store/models/Template'

export function getCategories(
  templates: Template[],
  featureChecker?: (feature: AllFeatureIds) => boolean
): Record<string, string> {
  const checkFeature = featureChecker ?? hasFeature

  return templates.reduce<Record<string, string>>((prev, current) => {
    const categorySlug = current.get('category_slug')
    const categoryName = current.get('category')

    if (featureIsNotActive(categorySlug, checkFeature)) return prev

    if (!prev[categorySlug]) {
      prev[categorySlug] = categoryName
    }

    return prev
  }, {})
}

function featureIsNotActive(
  categorySlug: string,
  checkFeature: (feature: AllFeatureIds) => boolean
): boolean {
  if (
    categorySlug.includes('employees') ||
    categorySlug.includes('payroll') ||
    categorySlug.includes('economic')
  ) {
    return false
  }

  const category = last(categorySlug.split('.'))

  if (!category) return true

  const features: Record<string, AllFeatureIds> = {
    shifts: 'time_tracking',
    shift_management: 'shift_management',
    e_signatures: 'esignature',
    timeoff: 'time_off',
    documents: 'documents',
    ats: 'ats',
  }

  const feature = features[category]

  if (!feature) return true

  return !checkFeature(feature)
}
